import styled from 'styled-components';

import colours from 'theme/atoms/colours';
import * as Text from 'theme/components/Text.style';
import { EventStatus } from 'events/_types';
import { OPEN_COLOUR, RESOLVED_COLOUR } from 'events/styles/DaySummary.style';

const STATUS_COLOURS: Record<EventStatus, string> = {
  open: OPEN_COLOUR,
  resolved: RESOLVED_COLOUR,
  auto_resolved: RESOLVED_COLOUR,
  invisible: colours.neutral[500],
};

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  width: 100%;
`;

export const StatusRow = styled.div<{ $status: EventStatus }>`
  align-items: center;
  color: ${({ $status }) => STATUS_COLOURS[$status]};
  display: flex;
  gap: 6px;

  svg {
    height: 16px;
    width: 16px;
  }
`;

export const StatusLabel = styled(Text.Label)`
  color: ${colours.neutral[900]};
`;

export const TagsRow = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 5px;

  .entity-tag-list,
  .entity-tag-list > div {
    display: contents;
  }
`;
